<div (scrolled)="onScroll()"
     [infiniteScrollDistance]="2"
     [infiniteScrollThrottle]="10"
     [scrollWindow]="false"
     class="table-wrapper overflow-auto xs:h-[calc(100vh-45rem)] sm:h-[calc(100vh-45rem)] md:h-[calc(100vh-30rem)]"
     infiniteScroll>
  <table (matSortChange)="sortData($event)"
         [class.hidden]="loading && isFirstPage"
         [dataSource]="dataSource"
         mat-table
         matSort>
    <!--    NAME-->
    <ng-container
      [sticky]="true"
      matColumnDef="name">
      <th *matHeaderCellDef
          class="md:w-[25rem] w-[15rem]"
          id="name"
          mat-header-cell
          mat-sort-header="name">
        <div class="th-cell">
          Group Name
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div class="td-cell md:w-[25rem] w-[15rem] break-words">
          <span (click)="groupNameClick(eachRow)"
                class="md:w-[25rem] w-[15rem] clickable"
          >
            {{ eachRow.name }}
          </span>
        </div>
      </td>
    </ng-container>
    <!--    COACHES-->
    <ng-container matColumnDef="coaches">
      <th *matHeaderCellDef
          class="w-[17rem] min-w-[17rem]"
          id="coaches"
          mat-header-cell>
        <div class="th-cell">
          Coaches
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div class="td-cell flex flex-col gap-[0.5rem] py-[1rem]">
          <div *ngFor="let eachAdmin of eachRow['coaches']"
               class="admin">
            <span (click)="coachNameClick(eachAdmin)"
                  *ngIf="eachAdmin.status != 1"
                  class="clickable"> {{
                eachAdmin.name
              }}</span>
            <span *ngIf="eachAdmin.status === 1"> {{ eachAdmin.name }}</span>
          </div>
        </div>
      </td>
    </ng-container>
    <!--    START DATE-->
    <ng-container matColumnDef="date">
      <th *matHeaderCellDef
          class="w-[15rem] min-w-[15rem]"
          id="startDate"
          mat-header-cell
          mat-sort-header="startDate">
        <div class="th-cell pl-[12px]">
          <span class="text-center">Start Date</span>
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div class="td-cell">
          {{ eachRow.startDate|date:'MM/dd/YYYY' }}
        </div>
      </td>
    </ng-container>
    <!--    TYPE-->
    <ng-container matColumnDef="type">
      <th *matHeaderCellDef
          class="w-[10rem] min-w-[10rem]"
          id="locationName"
          mat-header-cell
          mat-sort-header="locationName">
        <div class="th-cell pl-[12px]">
          Type
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div class="td-cell">
          {{ eachRow.locationName }}
        </div>
      </td>
    </ng-container>
    <!--    STATUS-->
    <ng-container matColumnDef="status">
      <th *matHeaderCellDef
          class="w-[15rem] min-w-[15rem]"
          id="status"
          mat-header-cell
          mat-sort-header="status">
        <div class="th-cell">
          Group Status
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div class="flex flex-row gap-[1rem] td-cell">
          <div [ngStyle]="{'background-color': groupStatusColors[eachRow?.status?.id]}"
               class="indicator">
          </div>
          <div class="status-text text">
            {{ eachRow?.status?.name }}
          </div>
        </div>
      </td>
    </ng-container>
    <!--    TOTAL PARTICIPANTS-->
    <ng-container matColumnDef="participantcount">
      <th *matHeaderCellDef
          class="w-[10rem] min-w-[10rem]"
          id="participantcount"
          mat-header-cell
          mat-sort-header="participantcount">
        <div class="th-cell pl-[12px]">
          Total Participants
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div class="td-cell">
          {{ eachRow.participantcount }}
        </div>
      </td>
    </ng-container>
    <!--    CURRENT SESSION-->
    <ng-container matColumnDef="currentSession">
      <th *matHeaderCellDef
          class="w-[10rem] min-w-[10rem]"
          id="lastSessionId"
          mat-header-cell
          mat-sort-header="lastSessionId">
        <div class="th-cell pl-[12px]">
          Current Session
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div (click)="sessionNameClick(eachRow)"
             class="td-cell">
          <span [class.clickable]="eachRow.lastSessionId !== null">
            {{
              eachRow.lastSessionId ? 'Session' + ' ' +
                eachRow.lastSessionId : ''
            }}
          </span>
        </div>
      </td>
    </ng-container>
    <!--    UPCOMING SESSION-->
    <ng-container matColumnDef="upcomingSession">
      <th *matHeaderCellDef
          class="w-[15rem] min-w-[15rem]"
          id="upcomingSession"
          mat-header-cell
          mat-sort-header="upcomingSession">
        <div class="th-cell pl-[12px]">
          <span class="text-center">Upcoming Session</span>
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div class="td-cell">
          {{
            eachRow.upcomingSession ? (eachRow.upcomingSession |
              date:'MM/dd/YYYY') : ''
          }}
        </div>
      </td>
    </ng-container>
    <!--    TOTAL ATTENDANCE-->
    <ng-container matColumnDef="totalAttendance">
      <th *matHeaderCellDef
          class="w-[10rem] min-w-[10rem]"
          id="averageAttendancePercentage"
          mat-header-cell
          mat-sort-header="averageAttendancePercentage">
        <div class="th-cell pl-[12px]">
          Average % Attendance
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div *ngIf="eachRow.averageAttendancePercentage" class="td-cell">
          {{ (eachRow.averageAttendancePercentage || 0) | number:'1.0-2' }}%
        </div>
      </td>
    </ng-container>
    <!--    ACTION MENU-->
    <ng-container matColumnDef="actionMenu">
      <th *matHeaderCellDef
          mat-header-cell>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem]"
          mat-cell>
        <button [matMenuTriggerFor]="menu"
                mat-icon-button>
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <ng-container
            *ngFor="let childMenu of actionMenu"
          >
            <ng-container
              *ngIf="!childMenu.status ||
              childMenu.status.includes(eachRow?.status?.id)"
            >
              <button
                (click)="childMenu.handleClick(eachRow)"
                mat-menu-item
              >
                <mat-icon>{{ childMenu.icon }}</mat-icon>
                <span class=" ">{{ childMenu.displayName }}</span>
              </button>
            </ng-container>

          </ng-container>
        </mat-menu>
      </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns; sticky: true"
        mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns;"
        mat-row></tr>

  </table>
  <div *ngIf="loading"
       [ngClass]="{ 'initial': isFirstPage }"
       class="table-loader w-full flex justify-center items-center">
    <mat-spinner/>
  </div>
  <div *ngIf="!loading && !dataSource.data?.length"
       class="no-data flex flex-col justify-center items-center">
    <div class="text">
      No data matching the filter.
    </div>
  </div>
</div>
